import React, { Suspense, lazy } from 'react';
import LandingPage from './components/Marketing/LandingPage';
import SpecialtyPage from './components/Marketing/SpecialtyPage';
import LegalPage from './components/Marketing/LegalPage';
import { findSpecialty } from './components/Marketing/specialtyData';

// El sistema se descarga solo al entrar a /app (o con una invitación), no en la web pública.
const SystemApp = lazy(() => import('./SystemApp'));

const isAppRoute = () =>
  window.location.pathname.startsWith('/app') || (window.location.search || '').includes('invite=');

function App() {
  if (isAppRoute()) {
    return (
      <Suspense fallback={<div style={{ minHeight: '100vh', background: 'var(--background, #f8fafc)' }} />}>
        <SystemApp />
      </Suspense>
    );
  }

  // Páginas públicas: /privacidad, /terminos y /<especialidad>. Cualquier otra ruta muestra la portada.
  const slug = window.location.pathname.replace(/^\/+|\/+$/g, '').toLowerCase();
  if (slug === 'privacidad' || slug === 'terminos') return <LegalPage kind={slug} />;
  const spec = findSpecialty(slug);
  if (spec) return <SpecialtyPage spec={spec} />;
  return <LandingPage />;
}

export default App;
